// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = require('./_wks')('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) require('./_hide')(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/modules/_add-to-unscopables.js
 ** module id = 97
 ** module chunks = 0
 **/